import { FormConfig, FormNavigationConfig, DefaultFormConfig, validatorRegisterLookup } from '@ptl/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { HTTPWrapperContext, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';
import { Person } from 'src/app/angular-elements/form-wrappers/form-components/individual-market-persons/interfaces/person.interface';
import { IndividualMarketStateStructure, RatingInfo } from '../../configs/interfaces/individualMarket.interfaceStateStructure';
import { AbstractControl } from '@angular/forms';
import { LOGIN_INFO_REDUCER_NAME, UserInfoStateStructure } from '@ptl/account-management';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndividualPlanEnrollmentService {

  private ratingInfoPagesAdded = false;

  private alphaMap: Map<number, string> = (() => {
    const map = new Map();

    // Populate the map with all 26 letters of the alphabet
    for (let i = 0; i < 26; i++) {
      map.set(i, String.fromCharCode(65 + i));
    }

    return map;
  })();

  spousePage;
  domesticPartnerAttestationPage;
  dependentsPage;
  dependentsChildOnlyPage;
  childOnlySummaryPage;

  firstNameValidationSubscriber = validatorRegisterLookup('subscriber-first-name')((control: AbstractControl) => {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
    let valid = true;
    const firstName = individualMarketPayload?.ratingInfo?.subscriber?.[0]?.firstName;

    if (firstName) {
      const curFirstName = (firstName || '').trim().toLowerCase();
      const sigFirstName = (control.value || '').trim().toLowerCase();
      valid = curFirstName === sigFirstName;
    }

    return !valid ? { 'parentGuardianSignature': true } : null;
  });
  middleNameValidationSubscriber = validatorRegisterLookup('subscriber-middle-initial')((control: AbstractControl) => {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
    let valid = true;
    const middleInitial = individualMarketPayload?.ratingInfo?.subscriber?.[0]?.middleInitial;

    if (middleInitial) {
      const curMidName = (middleInitial || '').trim().toLowerCase();
      const sigMidName = (control.value || '').trim().toLowerCase();
      valid = curMidName === sigMidName;
    }

    return !valid ? { 'parentGuardianSignature': true } : null;
  });
  lastNameValidationSubscriber = validatorRegisterLookup('subscriber-last-name')((control: AbstractControl) => {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
    let valid = true;
    const lastName = individualMarketPayload?.ratingInfo?.subscriber?.[0]?.lastName;

    if (lastName) {
      const curLastName = (lastName || '').trim().toLowerCase();
      const sigLastName = (control.value || '').trim().toLowerCase();
      valid = curLastName === sigLastName;
    }

    return !valid ? { 'parentGuardianSignature': true } : null;
  });

  firstNameValidationSpouse = validatorRegisterLookup('spouse-first-name')((control: AbstractControl) => {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
    let valid = true;
    const firstName = individualMarketPayload?.ratingInfo?.['spousal-partner']?.[0]?.firstName;

    if (firstName) {
      const curFirstName = (firstName || '').trim().toLowerCase();
      const sigFirstName = (control.value || '').trim().toLowerCase();
      valid = curFirstName === sigFirstName;
    }

    return !valid ? { 'parentGuardianSignature': true } : null;
  });
  middleNameValidationSpouse = validatorRegisterLookup('spouse-middle-initial')((control: AbstractControl) => {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
    let valid = true;
    const middleInitial = individualMarketPayload?.ratingInfo?.['spousal-partner']?.[0]?.middleInitial;

    if (middleInitial) {
      const curMidName = (middleInitial || '').trim().toLowerCase();
      const sigMidName = (control.value || '').trim().toLowerCase();
      valid = curMidName === sigMidName;
    }

    return !valid ? { 'parentGuardianSignature': true } : null;
  });
  lastNameValidationSpouse = validatorRegisterLookup('spouse-last-name')((control: AbstractControl) => {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
    let valid = true;
    const lastName = individualMarketPayload?.ratingInfo?.['spousal-partner']?.[0]?.lastName;

    if (lastName) {
      const curLastName = (lastName || '').trim().toLowerCase();
      const sigLastName = (control.value || '').trim().toLowerCase();
      valid = curLastName === sigLastName;
    }

    return !valid ? { 'parentGuardianSignature': true } : null;
  });

  firstNameValidationProducer = validatorRegisterLookup('producer-first-name')((control: AbstractControl) => {
    const loginInfoState: UserInfoStateStructure = this.reducerUtilityService.getApplicationStates()[LOGIN_INFO_REDUCER_NAME];
    let valid = true;
    const firstName = loginInfoState?.userInfo?.firstName;

    if (firstName) {
      const curFirstName = (firstName || '').trim().toLowerCase();
      const sigFirstName = (control.value || '').trim().toLowerCase();
      valid = curFirstName === sigFirstName;
    }

    return !valid ? { 'parentGuardianSignature': true } : null;

  });
  middleNameValidationProducer = validatorRegisterLookup('producer-middle-initial')((control: AbstractControl) => {
    const loginInfoState: UserInfoStateStructure = this.reducerUtilityService.getApplicationStates()[LOGIN_INFO_REDUCER_NAME];
    let valid = true;
    const middleInitial = loginInfoState?.userInfo?.middleInitial;
    
    // If the user NEEDS a middle initial OR they have ADDED one - run the logic
    // Because they might add a middle initial when one is not expected
    if (middleInitial || control.value) {
      const curMidName = (middleInitial || '').trim().toLowerCase();
      const sigMidName = (control.value || '').trim().toLowerCase();
      valid = curMidName === sigMidName;
    }

    return !valid ? { 'parentGuardianSignature': true } : null;
  });
  lastNameValidationProducer = validatorRegisterLookup('producer-last-name')((control: AbstractControl) => {
    const loginInfoState: UserInfoStateStructure = this.reducerUtilityService.getApplicationStates()[LOGIN_INFO_REDUCER_NAME];
    let valid = true;
    const lastName = loginInfoState?.userInfo?.lastName;

    if (lastName) {
      const curLastName = (lastName || '').trim().toLowerCase();
      const sigLastName = (control.value || '').trim().toLowerCase();
      valid = curLastName === sigLastName;
    }

    return !valid ? { 'parentGuardianSignature': true } : null;
  });

  address1ValidationSubscriber = validatorRegisterLookup('subscriber-address-1')((control: AbstractControl) => {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
    let valid = true;
    const address1 = individualMarketPayload?.ratingInfo?.['subscriber']?.[0]?.addressLine1;

    if (address1) {
      const curAddress1 = (address1 || '').trim().toLowerCase();
      const signedAddress1 = (control.value || '').trim().toLowerCase();
      valid = curAddress1 === signedAddress1;
    }

    return !valid ? { 'address1Signature': true } : null;
  });
  address2ValidationSubscriber = validatorRegisterLookup('subscriber-address-2')((control: AbstractControl) => {
    const individualMarketPayload: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
    let valid = true;
    const address2 = individualMarketPayload?.ratingInfo?.['subscriber']?.[0]?.addressLine2;

    if (address2) {
      const curAddress2 = (address2 || '').trim().toLowerCase();
      const signedAddress2 = (control.value || '').trim().toLowerCase();
      valid = curAddress2 === signedAddress2;
    }

    return !valid ? { 'address2Signature': true } : null;
  });

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private httpClient: HTTPWrapperContext,
  ) { }

  get dynamicPagesAlreadyAdded() { return this.ratingInfoPagesAdded; }
  set dynamicPagesAlreadyAdded(val) { this.ratingInfoPagesAdded = val; }


  async configureNonSubscriberPages(formConfig: DefaultFormConfig): Promise<DefaultFormConfig> {
    const individualMarketState: IndividualMarketStateStructure = this.reducerUtilityService.getPayloadState('individualMarket');
    const ratingInfo: RatingInfo = (individualMarketState && individualMarketState.ratingInfo) || {} as RatingInfo;

    const personsObjAsArray = (obj: { [key: string]: Person }): Person[] => {
      if (!obj || Object.keys(obj).length === 0) {
        return [];
      }

      const data: Person[] = [];
      Object.keys(obj).forEach((key: string, i: number) => data.push(obj[key]));
      return data;
    };

    /**
     * I don't feel like changing the interface at this time:
     *  1) if during about-you form flow - it will be a string
     *  2) if during review form flow - it will be a boolean
     */
    let isChildOnly = false;
    try {
      isChildOnly = individualMarketState?.childOnlyPolicy && individualMarketState?.childOnlyPolicy.toUpperCase() === 'YES';
    } catch (e) {
      isChildOnly = individualMarketState?.childOnlyPolicy as unknown as boolean;
    }

    const spousalPartnerArray: Person[] = personsObjAsArray(ratingInfo['spousal-partner']);
    const spousalPartner: Person = spousalPartnerArray[0];
    const dependentsArray: Person[] = personsObjAsArray(ratingInfo.dependents).filter((dependent) => dependent.dob != null);

    /** Splice in additional pages if necessary (or prevent it from occurring if already handled) */
    if (!this.dynamicPagesAlreadyAdded) {

      await this.getDynamicallyInsertedPages(formConfig);

      /** Splice dependent page into correct location */
      const personalInfoPageIndex = formConfig.pages.findIndex(p => p.pageHeader === 'Personal Information');

      /** Child-only */
      if (isChildOnly) {
        
        if (this.childOnlySummaryPage && this.dependentsPage) {

          /** Replace 'Personal Information' header */
          formConfig.pages
            .filter(p => p.pageHeader === 'Personal Information')
            .map(v => v.pageHeader = 'Parent/Guardian Information');

          const dependentsPageToSplice = this.dependentsChildOnlyPage ? this.dependentsChildOnlyPage : this.dependentsPage;
          formConfig.pages.splice(personalInfoPageIndex +1, 0, this.addDependentPages(dependentsArray, dependentsPageToSplice));

          let notificationPageIndexToSplice: number;
          formConfig.pages.findIndex((value, i) => {
            if (['Notifications & Authorizations','Producer Attestation'].includes(value.pageHeader)) {
              notificationPageIndexToSplice = i;
            }
          });

          formConfig.pages.splice(notificationPageIndexToSplice, 1, this.childOnlySummaryPage);

        }
      }

      if (!isChildOnly) {

        const spousalPartnerAdded = !!spousalPartner?.dob;
        const dependentsAdded = dependentsArray?.length > 0;

        if (spousalPartnerAdded && dependentsAdded) {
          if (this.spousePage && this.dependentsPage) {
            /** Spouse and Children */
            formConfig.pages.splice(personalInfoPageIndex +1, 0, this.spousePage);
            formConfig.pages.splice(personalInfoPageIndex +2, 0, this.addDependentPages(dependentsArray, this.dependentsPage));
          }
        }

        if (spousalPartnerAdded && !dependentsAdded) {
          if (this.spousePage) {
            /** Spouse-only */
            formConfig.pages.splice(personalInfoPageIndex +1, 0, this.spousePage);
          }
        }

        if (!spousalPartnerAdded && dependentsAdded) {
          if (this.dependentsPage) {
            /** Children-only */
            formConfig.pages.splice(personalInfoPageIndex +1, 0, this.addDependentPages(dependentsArray, this.dependentsPage));
          }
        }
      }

      /** This page component is rendered on subscriber/spouse/dependent pages */
      this.dynamicPagesAlreadyAdded = true;

    }

    return formConfig;
  }

  /**
   * 
   * Dynamically adds to the single dependent page numerous dependents
   * 
   * @param people
   * @param dependentsPage 
   * @returns An updated dependents page, containing multiple iterations of the dependent page ( 1 page, many dependents )
   */
  addDependentPages(people: Person[], dependentsPage): any {

    /** Make a first copy (we'll be modifying the original) */
    const entriesCopy = JSON.parse(JSON.stringify(dependentsPage.entries));

    people.forEach((person, i) => {

      /** Make a copy of the original copy (we'll be modifying this one before attaching) */
      const entriesTemplate = JSON.parse(JSON.stringify(entriesCopy));

      console.log('Processing person ' + i);

      entriesTemplate.forEach(entry => {

        /** Append index identifier */
        if (entry.formControlAttributes?.connectPath) {

          // Connect path to match dependent index
          // TODO: Keep this because it maps an array well.
          entry.formControlAttributes.connectPath = entry.formControlAttributes.connectPath.replace('{index}', i);
          entry.formControlAttributes.helperId = i + 1;

          /**
           * Because we are just duplicating the ENTRIES for DEPENDENTS ( 1 page, all dependents )
           * 1) we need to salt formControlNames which emit events to drive uniqueness
           * 2) we need to salt the listToFormControls item to align with (1)
           */
          const salt = `__${i}`;

          // Control name to match dependent index ( this is to resolve the copied entries needing unique identifiers )
          // TODO: Remove this, this is bad and makes it impossible to have a consistent payload for checking.
          if (entry.formControlAttributes.formControlName.includes('{index}')) {
            entry.formControlAttributes.formControlName = entry.formControlAttributes.formControlName.replace('{index}', salt);
          }

          // EventListener name to match dependent index ( this is to align with the formControlName change )
          if (entry.base?.formListeners) {
            entry.base.formListeners.forEach((listener, lIndex) => {

              if (listener?.linked === true) {
                entry.base.formListeners[lIndex].helperId = i + 1;
              }

              /** 
               * For cases where you might need to use the statePath, because the formControl you relied on is disabled,
               * Disabled form controls don't appear in the form itself and therefore aren't able to be matched the same way
               */
              if (listener.triggers) {
                listener.triggers.forEach( trigger => {
                  if (trigger.conditional) {
                    trigger.conditional.forEach( conditional => {
                      if (conditional.statePath) {
                        conditional.statePath = conditional.statePath.replace("{index}", i);
                      }
                    })
                  }
                })
              }

            });
          }
        }

        // Greatly increase the display order to ensure there is ample room to add new entries
        // ( dependent1 has entries from 0-999999, dependent2 has entries from 1000000-1999999, etc )
        entry.order = `${(1000000 * i) + entry.order}`;

        /**
         * Dependent 1, Dependent 2...
         * Dependent A, Dependent B...
         */
        if ( entry.custom?.swapTextIndexForTextAlpha ) {
          entry.base.text = entry.base.text.replace("{index}", this.alphaMap.get(i));
        }
        else if (entry.base?.text){
          entry.base.text = entry.base.text.replace("{index}", i+1);
        }

        /**
         * Some spacing between cloned dependent pages
         */
        if ( entry.custom?.addNewLineBeforeTextAfterIndex0 ) {
          if ( i > 0 ) {
            entry.base.text = "<br/>" + entry.base.text;
          }
        }

        /**
         * Hiding specific fields ( good for not repeating header )
         */
        if ( entry.custom?.displayOnce ) {
          if (i > 0) {
            entry.base.display = false;
          }
        }
      });

      if (i > 0) {
        dependentsPage.entries = dependentsPage.entries.concat(entriesTemplate);
      } else {
        dependentsPage.entries = entriesTemplate;
      }

    });

    return dependentsPage;
  }

  /**
   * 
   * This function takes some custom mappings for json file paths and fetches them, to be used later
   * 
   * @param formConfig JSON Form Config ( inside of which there should be a custom item listing some specific fields )
   */
  async getDynamicallyInsertedPages(formConfig: DefaultFormConfig): Promise<void> {

    const additionalPagePromises = [];

    let pushIndex = 0;
    let spousePageIndex: number;
    let domesticPartnerAttestationPageIndex: number;
    let dependentsPageIndex: number;
    let childOnlySummaryPageIndex: number;
    let dependentsChildOnlyPageIndex: number;

    // Spouse Info
    if (formConfig.form?.customConfigs?.spousePage) {
      additionalPagePromises.push(this.getDamPage(formConfig.form.customConfigs.spousePage));
      spousePageIndex = 0 + pushIndex;
      pushIndex++;
    }

    // Domestic Partner Attestation
    if (formConfig.form?.customConfigs?.domesticPartnerAttestationPage) {
      additionalPagePromises.push(this.getDamPage(formConfig.form.customConfigs.domesticPartnerAttestationPage));
      domesticPartnerAttestationPageIndex = 0 + pushIndex;
      pushIndex++;
    }

    // Dependent
    if (formConfig.form?.customConfigs?.dependentsPage) {
      additionalPagePromises.push(this.getDamPage(formConfig.form.customConfigs.dependentsPage));

      dependentsPageIndex = 0 + pushIndex;
      pushIndex++;
    }

    // Child-Only Summary
    if (formConfig.form?.customConfigs?.childOnlySummaryPage) {
      additionalPagePromises.push(this.getDamPage(formConfig.form.customConfigs.childOnlySummaryPage));

      childOnlySummaryPageIndex = 0 + pushIndex;
      pushIndex++;
    }

    // Dependent ( Child Only )
    if (formConfig.form?.customConfigs?.dependentsChildOnlyPage) {
      additionalPagePromises.push(this.getDamPage(formConfig.form.customConfigs.dependentsChildOnlyPage));

      dependentsChildOnlyPageIndex = 0 + pushIndex;
      pushIndex++;
    }

    const pageResponses = await Promise.all(additionalPagePromises);

    this.spousePage = pageResponses[spousePageIndex] ? pageResponses[spousePageIndex] : null;
    this.domesticPartnerAttestationPage = pageResponses[domesticPartnerAttestationPageIndex] ? pageResponses[domesticPartnerAttestationPageIndex] : null;
    this.dependentsPage = pageResponses[dependentsPageIndex] ? pageResponses[dependentsPageIndex] : null;
    this.childOnlySummaryPage = pageResponses[childOnlySummaryPageIndex] ? pageResponses[childOnlySummaryPageIndex] : null;
    this.dependentsChildOnlyPage = pageResponses[dependentsChildOnlyPageIndex] ? pageResponses[dependentsChildOnlyPageIndex] : null;

  }

  async getDamPage(url: string) {

    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url
    });

    this.httpClient.setStrategy(XHR_STRATEGIES.MOCK);
    return this.httpClient.makeRequest<any>(
      requestConfigImplementation
    );
  }

  toggleDomesticPartnerAttestationPage<T extends FormNavigationConfig>(formConfig: FormConfig<T>, shouldShow: boolean = false): FormConfig<T> {
    
    // If page is planned for addition, do the follow-up logic
    if (this.domesticPartnerAttestationPage) {
      if (shouldShow) {
        // Find Spouse Page
        const spousalPartnerPageIndex = formConfig.pages.findIndex(p => p.pageHeader === 'Spouse/Partner Information');
        // Confirm page isn't already present
        const domesticPartnerAttestationPageIndex = formConfig.pages.findIndex(p => p.pageHeader === 'Domestic Partner Declaration');
        if (domesticPartnerAttestationPageIndex === -1) {
          // Add attestation after
          formConfig.pages.splice(spousalPartnerPageIndex +1, 0, this.domesticPartnerAttestationPage);
        }
      } else {
        // Find Domestic Partner Attestation Page
        const domesticPartnerAttestationPageIndex = formConfig.pages.findIndex(p => p.pageHeader === 'Domestic Partner Declaration');
        
        // If exists - Remove it
        if (domesticPartnerAttestationPageIndex > 0) {
          formConfig.pages.splice(domesticPartnerAttestationPageIndex, 1);
        }
      }
    }

    return formConfig;
  }
}
